/**
 * CSORegisterService - CSO i Public Body registri (dodavanje, invalidacija, listanje).
 */

import ApiService from '@/core/api/ApiService';
import { API_ENDPOINTS } from '@/core/api/endpoints';

class CSORegisterService {
  async addCSORegister(name) {
    try {
      if (!name || !name.trim()) {
        throw new Error('Naziv registra je obavezan');
      }

      const response = await ApiService.post(API_ENDPOINTS.CSO.REGISTER.ADD, {
        name: name.trim(),
      });

      if (response.data) {
        return response.data;
      }

      return { name: name.trim() };
    } catch (error) {
      if (error.response && error.response.status === 401) {
        throw new Error('Korisnik nije prijavljen');
      }

      if (error.response && error.response.status === 400) {
        const errorMessage = error.response.data?.message || 'Neispravni podaci registra';
        throw new Error(errorMessage);
      }

      throw error;
    }
  }

  async invalidateCSORegister(id) {
    try {
      if (!id) {
        throw new Error('ID registra je obavezan');
      }

      const response = await ApiService.post(API_ENDPOINTS.CSO.REGISTER.INVALIDATE, {
        id: id,
      });

      if (response.data) {
        return response.data;
      }

      return { success: true };
    } catch (error) {
      if (error.response && error.response.status === 401) {
        throw new Error('Korisnik nije prijavljen');
      }

      if (error.response && error.response.status === 403) {
        throw new Error('Nemate dozvolu za invalidaciju registara');
      }

      if (error.response && error.response.status === 404) {
        throw new Error('Registar nije pronađen');
      }

      if (error.response && error.response.status === 400) {
        const errorMessage = error.response.data?.message || 'Greška pri invalidaciji registra';
        throw new Error(errorMessage);
      }

      throw error;
    }
  }

  async getAllCSORegisters() {
    try {
      const response = await ApiService.get(API_ENDPOINTS.CSO.REGISTER.LIST);

      if (response.data) {
        if (response.data.cso_registers && Array.isArray(response.data.cso_registers)) {
          return response.data.cso_registers;
        }
        if (response.data.csoRegisters && Array.isArray(response.data.csoRegisters)) {
          return response.data.csoRegisters;
        }
        if (Array.isArray(response.data)) {
          return response.data;
        }
      }

      return [];
    } catch (error) {
      if (error.response && error.response.status === 401) {
        throw new Error('Korisnik nije prijavljen');
      }

      throw error;
    }
  }

  async addPublicBodyRegister(name) {
    try {
      if (!name || !name.trim()) {
        throw new Error('Naziv registra je obavezan');
      }

      const response = await ApiService.post(API_ENDPOINTS.PUBLIC_BODY.REGISTER.ADD, {
        name: name.trim(),
      });

      if (response.data) {
        return response.data;
      }

      return { name: name.trim() };
    } catch (error) {
      if (error.response && error.response.status === 401) {
        throw new Error('Korisnik nije prijavljen');
      }

      if (error.response && error.response.status === 400) {
        const errorMessage = error.response.data?.message || 'Neispravni podaci registra';
        throw new Error(errorMessage);
      }

      throw error;
    }
  }

  async invalidatePublicBodyRegister(id) {
    try {
      if (!id) {
        throw new Error('ID registra je obavezan');
      }

      const response = await ApiService.post(API_ENDPOINTS.PUBLIC_BODY.REGISTER.INVALIDATE, {
        id: id,
      });

      if (response.data) {
        return response.data;
      }

      return { success: true };
    } catch (error) {
      if (error.response && error.response.status === 401) {
        throw new Error('Korisnik nije prijavljen');
      }

      if (error.response && error.response.status === 403) {
        throw new Error('Nemate dozvolu za invalidaciju registara');
      }

      if (error.response && error.response.status === 404) {
        throw new Error('Registar nije pronađen');
      }

      if (error.response && error.response.status === 400) {
        const errorMessage = error.response.data?.message || 'Greška pri invalidaciji registra';
        throw new Error(errorMessage);
      }

      throw error;
    }
  }

  async getAllPublicBodyRegisters() {
    try {
      const response = await ApiService.get(API_ENDPOINTS.PUBLIC_BODY.REGISTER.LIST);

      if (response.data) {
        if (response.data.public_body_registers && Array.isArray(response.data.public_body_registers)) {
          return response.data.public_body_registers;
        }
        if (response.data.publicBodyRegisters && Array.isArray(response.data.publicBodyRegisters)) {
          return response.data.publicBodyRegisters;
        }
        if (Array.isArray(response.data)) {
          return response.data;
        }
      }

      return [];
    } catch (error) {
      if (error.response && error.response.status === 401) {
        throw new Error('Korisnik nije prijavljen');
      }

      throw error;
    }
  }
}

const csoRegisterServiceInstance = new CSORegisterService();
export default csoRegisterServiceInstance;
